import { Link } from "react-router-dom";
import { ROUTES } from "../Routes";

const Navigation = () => {
  return (
    <header>
      <div className="container">
        <div className="header-content">
          <span className="roofline" aria-hidden="true"></span>
          <Link to="/" className="logo" aria-label="Talox Games">
            Talox Games
          </Link>

          <div className="user-menu">
            <div className="auth-buttons">
              <Link to={ROUTES.LOGIN}>SIGN IN</Link>
              <Link to={ROUTES.REGISTER}>CREATE ACCOUNT</Link>
            </div>
          </div>
        </div>
      </div>
    </header>

  );

};

export default Navigation;